import { TableContainer, Tbody, Thead, Tr, Table as ChakraTable, useToast, Button, Flex, Th } from "@chakra-ui/react";
import { useEffect } from "react";
import { useState } from "react";
import { Loader } from "../../../components/ComponentLoader/Loader";
import { baseURL } from "../../../services/api";
import { UsageTh } from "./UsageTh";
import { UsageTr } from "./UsageTr";
import { ComponentSoma } from "./ComponentSoma";

const imgSubmitting = "/images/loading-verde.gif";

export function Table({ data, isSubmitting }) {
  const [clientHeightScreen, setClientHeightScreen] = useState(0);
  const heightTable = clientHeightScreen - 400;

  const [nunota, setNunota] = useState([]);
  const [codProd, setCodProd] = useState([]);
  const [sequencia, setSequencia] = useState([]);
  const [loading, setLoading] = useState(false);

  // const dataSorted = data.sort((a, b) => {
  //   return a.credito_utilizado === "S" ? 1 : -1;
  // });

  const toast = useToast();

  useEffect(() => {
    window.addEventListener("resize", () => {
      setClientHeightScreen(window.innerHeight);
    });
  }, []);

  async function checkForn() {
    if (nunota.length === 0) {
      toast({
        position: "top-right",
        title: "Selecione ao menos um crédito",
        description: "Selecione ao menos um crédito a ser utilizado",
        status: "error",
        duration: 6000,
        isClosable: true,
      });
      return;
    }

    const params = {
      numero_nota: nunota,
      codprod: codProd,
      sequencia,
    };
    try {
      setLoading(true);

      const response = await baseURL.post("/pedido/atualiza-status-credito-devolucao", params);

      console.log(response);

      toast({
        position: "top-right",
        title: "Status atualizado com sucesso",
        description: "Seu crédito foi atualizado",
        status: "success",
        duration: 6000,
        isClosable: true,
      });
    } catch (error) {
      console.log(error);

      toast({
        position: "top-right",
        title: "Erro ao atualizar status",
        description: "Tente novamente mais tarde",
        status: "error",
        duration: 6000,
        isClosable: true,
      });

      setLoading(false);
    }
    console.log(params);
    setLoading(false);
  }

  return (
    <>
      <TableContainer textAlign="center" height={heightTable} overflowY="auto" overFlowX="auto">
        <ChakraTable variant="striped" colorScheme="gray" fontSize="0.7rem">
          <Thead textAlign="center" px="6rem" position="sticky" top="0" zIndex="1">
            <Tr bg="#F4F5F5" color="white" mx="6rem" w="100%">
              <Th width="100%"></Th>
              <Th width="100%"></Th>
              <Th width="100%"></Th>
              <Th width="100%"></Th>
              <Th width="100%"></Th>
              <Th width="100%"></Th>
              <Th width="100%"></Th>
              <Th width="100%"></Th>
              <Th width="100%"></Th>
              <Th width="100%"></Th>
              <Th width="100%"></Th>
              <Th width="100%"></Th>
              <Th width="100%"></Th>
              <Th width="100%" bg="#378BBF" color="white">
                Total: <ComponentSoma data={data} />
              </Th>
              <Th width="100%" padding="0">
                {" "}
                <Flex width="100%" justifyContent="flex-end" alignItems="flex-end">
                  {" "}
                  <Button
                    onClick={checkForn}
                    color="white"
                    borderRadius="0"
                    fontSize="0.7rem"
                    disabled={isSubmitting}
                    variant={isSubmitting ? "outline" : "solid"}
                    bg={isSubmitting ? "gray.300" : "green.500"}
                    _hover={{ bg: isSubmitting ? "gray.300" : "green.600" }}
                    isLoading={loading}
                    textTransform="uppercase"
                  >
                    Confirmar CRÉDITO UTILIZADO
                  </Button>
                </Flex>
              </Th>
            </Tr>
          </Thead>
          <Thead textAlign="center" px="6rem" position="sticky" top="40px" zIndex="1">
            <Tr bg="#378BBF" color="white" mx="6rem">
              <UsageTh text="DATA DO PEDIDO" />
              <UsageTh text="DATA DE DEVOLUÇÃO" />
              <UsageTh text="PEDIDO VENDA	" />
              <UsageTh text="CÓD. INNOVATION" />
              <UsageTh text="DESCRIÇÃO" />
              <UsageTh text="COR DO PROD" />
              <UsageTh text="CÓD. FORN" />
              <UsageTh text="QTD" />
              <UsageTh text="Limite Produção" />
              <UsageTh text="Pedido Troca" />
              <UsageTh text="Pedido Compra" />
              <UsageTh text="Vlr. Un. pedido." />
              <UsageTh text="Vlr. Tot. Pedido." />
              <UsageTh text="CRÉDITO DISPONÍVEL." />
              <UsageTh text="Crédito utilizado" />
            </Tr>
          </Thead>

          <Tbody>
            {!isSubmitting &&
              data.map((item, index) => {
                if (item.credito_utilizado !== "S") {
                  return (
                    <UsageTr
                      key={index}
                      data={item}
                      setNunota={setNunota}
                      setCodProd={setCodProd}
                      setSequencia={setSequencia}
                      nunota={nunota}
                      codProd={codProd}
                      sequencia={sequencia}
                    />
                  );
                }
              })}
          </Tbody>
        </ChakraTable>
        {isSubmitting && <Loader img={imgSubmitting} />}
      </TableContainer>
    </>
  );
}
